import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsAndConditions } from './pages/TermsAndConditions';
import { SocialProofNotification } from './components/SocialProofNotification';
import { MetaPixelTracker } from './components/MetaPixelTracker';
export function App() {
  return <HashRouter data-id="element-0">
      {/* Meta Pixel — initializes once, fires PageView on every route change */}
      <MetaPixelTracker data-id="element-1" />
      <div className="w-full min-h-screen bg-white overflow-x-hidden" data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-5" />} data-id="element-4" />
          <Route path="/terms-and-conditions" element={<TermsAndConditions data-id="element-7" />} data-id="element-6" />
          {/* Fallback for any other path — including "/" and preview paths */}
          <Route path="*" element={<LandingPage data-id="element-9" />} data-id="element-8" />
        </Routes>
        {/* Social proof toast — fixed positioned, root-level, never inside any section */}
        <SocialProofNotification data-id="element-10" />
      </div>
    </HashRouter>;
}